import { CodeChangesPanel } from "@/routes/environments/details/CodeChangesPanel";
import { GitStatusPanelCompact } from "@/routes/environments/details/GitStatusPanelCompact";
import type { FC } from "react";

export type EnvironmentChangesViewProps = {
    environmentId: string;
};

export const EnvironmentChangesView: FC<EnvironmentChangesViewProps> = ({ environmentId }) => {
    return (
        <div className={"flex grow flex-col gap-2 @container"} data-testid="environment-changes-view">
            <GitStatusPanelCompact environmentId={environmentId} />
            <CodeChangesPanel environmentId={environmentId} />
        </div>
    );
};
